import * as Helpers from '../lib/ACHelpers'

import { createToken } from "../data/DocumentListActions";
import { checkHealth } from '../data/EditorActions';
import * as Constant from '../data/constant';

const THUMBNAIL_DOCUMENTS = 'THUMBNAIL_DOCUMENTS';

export default class ThumbnailGenerationService {

  constructor() {
    this.thumbnailGenerationInterval = undefined;
    this.isProcessing = false;
  }

  static getInstance() {
    if (!ThumbnailGenerationService.instance) {
      ThumbnailGenerationService.instance = new ThumbnailGenerationService();
    }
    return ThumbnailGenerationService.instance;
  }

  startProcess() {
    if (this.thumbnailGenerationInterval) {
      window.clearInterval(this.thumbnailGenerationInterval);
    }

    this.thumbnailGenerationInterval = window.setInterval(async () => {
      await this.thumbnailGeneration();
    }, Constant.THUMBNAIL_GENERATION_INTERVAL);
  }

  async thumbnailGeneration() {
    const userId = sessionStorage.getItem('uid') ? parseInt(sessionStorage.getItem('uid'), 10) : undefined;
    if (this.isProcessing || !userId) {
      return;
    }

    this.isProcessing = true;

    const thumbnailDocs = [...Helpers.getStorageItem(THUMBNAIL_DOCUMENTS).values()].filter(item => parseInt(item.userId, 10) === userId);
    if (thumbnailDocs.length > 0) {
      await checkHealth().then(async () => {
        const token = await createToken();
        for (let thumbnail of thumbnailDocs) {
          await this.generateThumbnail(thumbnail.gridDocumentId, thumbnail.userId, token);
        }
      }).catch((error) => {
        // console.log('Thumbnail Generation Error: ', error);
      });
    }

    this.isProcessing = false;
  }

  async generateThumbnail(gridDocumentId, userId, token) {
    if (!token || !userId) {
      return Promise.resolve();
    }

    return await Helpers.fetchJson(Constant.micro_url + '/export/remote/' + gridDocumentId + '?uid=' + userId + '&shareToken=' + token + '&isgeneratethumbnail=true&format=jpg' + '&ownerId=' + userId + '&authToken=' + token)
      .then((response) => {
        let thumbnailDocs = Helpers.getStorageItem(THUMBNAIL_DOCUMENTS);
        thumbnailDocs.delete(gridDocumentId);
        Helpers.setStorageItem(THUMBNAIL_DOCUMENTS, thumbnailDocs);
      })
      .catch((error) => { });
  }

  add(gridDocumentId, userId) {
    let thumbnailDocs = Helpers.getStorageItem(THUMBNAIL_DOCUMENTS);
    thumbnailDocs.set(gridDocumentId, {
      gridDocumentId,
      userId
    });
    Helpers.setStorageItem(THUMBNAIL_DOCUMENTS, thumbnailDocs);
  }
}



// WEBPACK FOOTER //
// ./src/services/ThumbnailGenerationService.js